import { getData } from '../get-table'
import { HttpService } from '../http.service'
import { usePayrollStore } from '@/store/payroll-data'

const http = new HttpService()

export interface employeeData {
  code: string
  leaveDate: string
  leaveReasonId: string
  positionId: string
  journeyId: string
  sucursalId: string
  turnId: string
  directionId: string
  managementId: string
  costCenterId: string
  departmentId: string
}

export interface TransferRequest {
  payrollOriginId: string
  payrollDestinationId: string
  employeeOriginId: string
  employee: employeeData
  statusId?: string
  observations: string
}

export async function createTransferRequest(
  data: TransferRequest
): Promise<boolean> {
  const response: any = await http.post('transfers/create-request', data)

  if (response?.data?.data?.error) {
    return false
  }
  return response.data.id
}

//---------------------transfer requests---------------------//

export async function getTransferRequests(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = [
    'transfer_requests.payroll_origin_id=:payrollId OR transfer_requests.payroll_destination_id=:payrollId',
  ]
  if (search) {
    where.push(
      `CONCAT(payrolls.name,employees.name,transfer_requests.observation) ILIKE '%${search}%'`
    )
  } 
  // order by
  let modifier = []
  dataOrder !== ''
    ? (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = ['order by transfer_requests.updated_at desc'])
  // result
  const response: any = await getData({
    tables: ['pg_transfer_requests'],
    fields: [
      'transfer_requests.id as id',
      'payrolls_orig.name as payrollOrigin',
      'payrolls_dest.name as payrollDestination',
      'employees.name as employeeOrigin',
      'transfer_requests.summary as summary',
      'process_status.name as statusProcess',
      'transfer_requests.created_by as creationUser',
      'transfer_requests.updated_at',
      'transfer_requests.created_at',
      'transfer_requests.closed_by'
    ],
    join: [
      'LEFT JOIN process_status ON transfer_requests.status_id=process_status.id',
      'LEFT JOIN payrolls payrolls_orig ON transfer_requests.payroll_origin_id=payrolls_orig.id',
      'LEFT JOIN payrolls payrolls_dest ON transfer_requests.payroll_destination_id=payrolls_dest.id',
      'LEFT JOIN employees ON transfer_requests.employee_origin_id=employees.id'
    ],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response[0]
}

export async function getTransferRequestId(
  id: string
): Promise<any> {

  const where = [
      `transfer_requests.id='${id}'`,
  ]

  const response: any = await getData({
    tables: ['pg_transfer_requests'],
    fields: [
      'transfer_requests.payroll_origin_id as payrollOriginId',
      'transfer_requests.payroll_destination_id as payrollDestinationId',
      'transfer_requests.summary as summary',
      'transfer_requests.employee as employee',
      'process_status.code as statusProcess',
      'transfer_requests.created_by as creationUser',
      'transfer_requests.updated_at',
      'transfer_requests.created_at'
    ],
    join: [
      'LEFT JOIN process_status ON transfer_requests.status_id=process_status.id',
      'LEFT JOIN employees ON transfer_requests.employee_origin_id=employees.id'
    ],
    where,
    options: {
    }
  })
  return response[0].results[0]
}

export async function getFieldsTransfer(
  id: string,
  table: string
): Promise<any> {
  const response: any = await http.post('transfers/get-elements', {
    id,
    table
  })

  if (response?.data?.data?.error) {
    return false
  }

  response.data.forEach((element: any) => {
    element.send = false
  })

  return response.data
}

//---------------------send transfer element---------------------//

export async function sendRowsTransfer(id:string, table: string, rows: any[]) {
  const response: any = await http.post('transfers/create-elements', {
    id,
    table,
    elements: rows
  })

  if (response?.data?.data?.error) {
    return false
  }
  return response.data
}

export async function closeTransferRequest(
  data: any
): Promise<boolean> {
  const response: any = await http.post('transfers/close-request', data)

  if (response?.data?.data?.error) {
    return false
  }
  return response.data.id
}

//---------------------payrolls---------------------//

export async function getPayrollInfo(id : string= '') {
  let where
  if(id === '') 
    where = ['payrolls.id=:payrollId']
  else
    where = [`payrolls.id='${id}'`]
  
  const response: any = await getData({
    tables: ['pg_payrolls'],
    fields: [
      'payrolls.id as id',
      'payrolls.name as name',
      'payrolls.code as code',
      'payrolls.last_payment as lastPayment',
      'currencies.name as currency',
      'currencies.symbol as currencySymbol',
      'frequencies.name as frequency',
      'countries.id as countryId',
      'countries.name as country',
      'countries.iso_code as isoCode',
      'companies.name as companyName',
      'companies.code as companyCode',
      'companies.id as companyId',
    ],
    join: [
      'LEFT JOIN currencies ON payrolls.currency_id=currencies.id',
      'LEFT JOIN frequencies ON payrolls.frequency_id=frequencies.id',
      'LEFT JOIN companies ON payrolls.company_id=companies.id',
      'LEFT JOIN countries ON companies.country_id=countries.id',
    ],
    where,
    options: {
      outputFormat: 'json'
    }
  })
  return response[0].results[0]
}

export async function getPayrollsDestination(countryId: string) {
  const where = [
    `countries.id='${countryId}'`,
  ]
  const response: any = await getData({
    tables: ['pg_payrolls'],
    fields: [
      'payrolls.id as id',
      'payrolls.code as code',
      'CONCAT(payrolls.code,\' - \',payrolls.name) as name',
      'payrolls.last_payment as lastPayment',
      'currencies.name as currency',
      'currencies.symbol as currencySymbol',
      'frequencies.name as frequency',
      'countries.id as countryId',
      'countries.name as country',
      'countries.iso_code as isoCode',
      'companies.name as companyName',
      'companies.code as companyCode',
      'companies.id as companyId'
    ],
    join: [
      'LEFT JOIN currencies ON payrolls.currency_id=currencies.id',
      'LEFT JOIN frequencies ON payrolls.frequency_id=frequencies.id',
      'LEFT JOIN companies ON payrolls.company_id=companies.id',
      'LEFT JOIN countries ON companies.country_id=countries.id'
    ],
    where,
    options: {
      outputFormat: 'json'
    }
  })
  return response[0].results
}

//---------------------employees---------------------//

export async function getInfoEmployeeById(employeeId:string){
  const where = [
    `employees.id='${employeeId}'`,
  ]
  const response: any = await getData({
    tables: ['pg_employees'],
    fields: [
      'employees.id as id',
      'CONCAT(employees.code,\' - \',employees.name) as name',
      'employees.joining_date as joiningDate',
      'CONCAT(positions.code,\' - \',positions.name) as position',
      'CONCAT(sucursals.code,\' - \',sucursals.name) as sucursal',
      'CONCAT(directions.code,\' - \',directions.name) as direction',
      'CONCAT(managements.code,\' - \',managements.name) as management',
      'CONCAT(departments.code,\' - \',departments.name) as department',
      'CONCAT(journeys.code,\' - \',journeys.name) as journey',
      'CONCAT(turns.code,\' - \',turns.name) as turn',
    ],
    where,
    join: [
      'LEFT JOIN positions ON employees.position_id=positions.id',
      'LEFT JOIN sucursals ON employees.sucursal_id=sucursals.id',
      'LEFT JOIN directions ON employees.direction_id=directions.id',
      'LEFT JOIN managements ON employees.management_id=managements.id',
      'LEFT JOIN departments ON employees.department_id=departments.id',
      'LEFT JOIN journeys ON employees.journey_id=journeys.id',
      'LEFT JOIN turns ON employees.turn_id=turns.id'
    ],
    options: {
      outputFormat: 'json'
    }
  })
  return response[0].results[0]
}

export async function getInfoEmployees() {
  const where = [
    `employees.payroll_id=:payrollId`
  ]
  const response: any = await getData({
    tables: ['pg_employees'],
    fields: [
      'employees.id as id',
      'CONCAT(employees.code,\' - \',employees.name) as name'
    ],
    where,
    options: {
      outputFormat: 'json'
    }
  })
  return response[0].results
}

export async function checkEmployeeCodeExists(payrollId: string, employeeCode: string) {
  const where = [
    `employees.payroll_id='${payrollId}'`,
    `employees.code='${employeeCode}'`
  ]
  const response: any = await getData({
    tables: ['pg_employees'],
    fields: [
      'employees.id as id',
      'employees.code as code'
    ],
    where,
    options: {
      outputFormat: 'json'
    }
  })
  return response[0].results.length > 0
}

//---------------------organization data---------------------//

export async function getReasons(countryId: string) {
  const where = [
    `country_id='${countryId}'`,
  ]
  const response: any = await getData({
    tables: ['pg_leave_reasons'],
    fields: [
      'leave_reasons.id as id',
      'CONCAT(leave_reasons.code,\' - \',leave_reasons.name) as name',
    ],
    where,
    options: {
      outputFormat: 'json'
    }
  })
  return response[0].results
}

export async function getPositions(countryId: string) {
  const where = [
    `country_id='${countryId}'`,
  ]
  const response: any = await getData({
    tables: ['pg_positions'],
    fields: [
      'positions.id as id',
      'CONCAT(positions.code,\' - \',positions.name) as name',
    ],
    where,
    options: {
      outputFormat: 'json'
    }
  })
  return response[0].results
}

export async function getJourneys(countryId: string){
  const where = [
    `country_id='${countryId}'`,
  ]
  const response: any = await getData({
    tables: ['pg_journeys'],
    fields: [
      'journeys.id as id',
      'CONCAT(journeys.code,\' - \',journeys.name) as name',
    ],
    where,
    options: {
      outputFormat: 'json'
    }
  })
  return response[0].results
}
  

export async function getSucursals(companyId: string) {
  const where = [
    `company_id='${companyId}'`,
  ]
  const response: any = await getData({
    tables: ['pg_sucursals'],
    fields: [
      'sucursals.id as id',
      'CONCAT(sucursals.code,\' - \',sucursals.name) as name',
    ],
    where,
    options: {
      outputFormat: 'json'
    }
  })
  return response[0].results
}

export async function getTurns(sucursalId: string){
  const where = [
    `sucursal_id='${sucursalId}'`,
  ]
  const response: any = await getData({
    tables: ['pg_turns'],
    fields: [
      'turns.id as id',
      'CONCAT(turns.code,\' - \',turns.name) as name',
    ],
    where,
    options: {
      outputFormat: 'json'
    }
  })
  return response[0].results
}

export async function getDirections(companyId: string) {
  const where = [
    `company_id='${companyId}'`,
  ]
  const response: any = await getData({
    tables: ['pg_directions'],
    fields: [
      'directions.id as id',
      'CONCAT(directions.code,\' - \',directions.name) as name',
    ],
    where,
    options: {
      outputFormat: 'json'
    }
  })
  return response[0].results
}

export async function getCostCenters(companyId: string) {
  const where = [
    `company_id='${companyId}'`,
  ]
  const response: any = await getData({
    tables: ['pg_cost_centers'],
    fields: [
      'cost_centers.id as id',
      'CONCAT(cost_centers.code,\' - \',cost_centers.name) as name',
    ],
    where,
    options: {
      outputFormat: 'json'
    }
  })
  return response[0].results
}

export async function getManagements(directionId: string) {
  const where = [
    `direction_id='${directionId}'`,
  ]
  const response: any = await getData({
    tables: ['pg_managements'],
    fields: [
      'managements.id as id',
      'CONCAT(managements.code,\' - \',managements.name) as name',
    ],
    where,
    options: {
      outputFormat: 'json'
    }
  })
  return response[0].results
}

export async function getDepartments(managementId: string, costCenterId: string) {
  console.log(managementId, costCenterId)
  const where = [
    `management_id='${managementId}'`,
    `cost_center_id='${costCenterId}'`,
  ]
  const response: any = await getData({
    tables: ['pg_departments'],
    fields: [
      'departments.id as id',
      'CONCAT(departments.code,\' - \',departments.name) as name',
    ],
    where,
    options: {
      outputFormat: 'json'
    }
  })
  return response[0].results
}
